<header class="emptyHeaderMain"></header>
<div class="container">
  <div class="sessions">
    <div class="select-all" (click)="toggleAll()">
      <input
        type="checkbox"
        [checked]="sessions && selectedSessions.length === sessions.length" />
      All
    </div>
    <div
      class="session"
      *ngFor="let session of sessions"
      (click)="toggleSelection(session)">
      <input type="checkbox" [checked]="selectedSessions.includes(session)" />
      {{ session.config.title }}
    </div>
  </div>

  <br />
  <br />
  <br />

  <div class="controls">
    <div class="control">
      <h3>"You Were Added As Collaborator"</h3>
      <p>
        Whether to send an email to someone who is added as a collaborator to
        some idea.
      </p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.collaborator.added.you === true }"
          (click)="set('collaborator.added.you', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.collaborator.added.you === false }"
          (click)="set('collaborator.added.you', false)">
          Dont Send
        </button>
      </div>
    </div>

    <div class="control">
      <h3>"Someone Was Added As Collaborator"</h3>
      <p>
        Whether to send an email to other collaborators and the originator of an
        idea when a new collaborator is added.
      </p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.collaborator.added.someone === true }"
          (click)="set('collaborator.added.someone', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.collaborator.added.someone === false }"
          (click)="set('collaborator.added.someone', false)">
          Dont Send
        </button>
      </div>
    </div>

    <div class="control">
      <h3>"Someone Has Requested To Be Added As Collaborator"</h3>
      <p>
        Whether to send an email to other collaborators and the originator of an
        idea when someone has requested to be added as collaborator.
      </p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.collaborator.requested === true }"
          (click)="set('collaborator.requested', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.collaborator.requested === false }"
          (click)="set('collaborator.requested', false)">
          Dont Send
        </button>
      </div>
    </div>

    <div class="control">
      <h3>"Someone Added A Comment"</h3>
      <p>
        Whether to send an email to other collaborators and the originator of an
        idea when someone adds a comment.
      </p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.comment.added === true }"
          (click)="set('comment.added', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.comment.added === false }"
          (click)="set('comment.added', false)">
          Dont Send
        </button>
      </div>
    </div>

    <div class="control">
      <h3>"Someone Replied To A Comment"</h3>
      <p>
        Whether to send an email to someone when there is a reply to one of
        their comments.
      </p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.comment.replied === true }"
          (click)="set('comment.replied', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.comment.replied === false }"
          (click)="set('comment.replied', false)">
          Dont Send
        </button>
      </div>
    </div>

    <div class="control">
      <h3>"Someone Was Mentioned In A Comment"</h3>
      <p>Whether to send an email to someone who is mentioned in a comment.</p>
      <div class="buttons">
        <button
          [ngClass]="{ active: settings.comment.mentioned === true }"
          (click)="set('comment.mentioned', true)">
          Send
        </button>
        <button
          [ngClass]="{ active: settings.comment.mentioned === false }"
          (click)="set('comment.mentioned', false)">
          Dont Send
        </button>
      </div>
    </div>
  </div>
</div>
